/* Lashthing 2026-09-14: houdt het "Dit ontvang je"-blok gelijk aan de gekozen variant.
 * Alleen nodig op de kits met de optie "Type Wimper" (Basic/Premium/Deluxe): bij een wissel
 * tussen Natural (Shei) en Extra (Monica) wisselt de foto van de wimperstrip mee en komt de
 * gekozen stijl + lengte onder de kaart te staan.
 * De eerste weergave staat al goed via Liquid; dit script corrigeert alleen NA een wissel.
 * Leest de variantkeuze uit de Globo Color Swatch-DOM (zoals lt-type-swatch.js) en valt
 * terug op Dawn's eigen variant-inputs. Zonder JS verandert er niets. */
(function () {
  'use strict';

  var CFG = window.LT_KIT_CONTENTS;
  if (!CFG) return;

  var root = document.querySelector('[data-lt-kit]');
  if (!root) return;

  var img = root.querySelector('[data-lt-kit-img]');
  var sub = root.querySelector('[data-lt-kit-sub]');
  if (!img && !sub) return;

  function normalizeName(value) {
    return String(value || '').trim().toLowerCase();
  }

  /* Globo rendert de opties als .swatch--gl met een <legend class="name-option">. */
  function globoValue(optionName) {
    var blocks = document.querySelectorAll('.globo-swatch-product-detail .swatch--gl');
    for (var i = 0; i < blocks.length; i++) {
      var legend = blocks[i].querySelector('legend.name-option');
      var name = legend
        ? normalizeName(legend.getAttribute('data-name') || (legend.firstChild && legend.firstChild.textContent))
        : '';
      if (name === optionName) {
        var checked = blocks[i].querySelector('input:checked');
        return checked ? checked.value : '';
      }
    }
    return '';
  }

  /* Terugval: Dawn's eigen variant-picker (fieldset met legend.form__label). */
  function dawnValue(optionName) {
    var fieldsets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && normalizeName(legend.textContent).indexOf(optionName) === 0) {
        var checked = fieldsets[i].querySelector('input:checked');
        if (checked) return checked.value;
      }
    }
    var selects = document.querySelectorAll('variant-selects select');
    for (var j = 0; j < selects.length; j++) {
      var label = selects[j].closest('.product-form__input');
      var text = label ? normalizeName(label.textContent) : '';
      if (text.indexOf(optionName) === 0) return selects[j].value;
    }
    return '';
  }

  function optionValue(optionName) {
    return globoValue(optionName) || dawnValue(optionName);
  }

  /* "Natural (shei)" -> "Natural (Shei)" */
  function prettify(value) {
    return String(value || '').replace(/\(([^)]+)\)/, function (all, inner) {
      inner = inner.trim();
      return '(' + inner.charAt(0).toUpperCase() + inner.slice(1).toLowerCase() + ')';
    });
  }

  var lastKey = '';

  function apply() {
    var type = optionValue('type wimper');
    var length = optionValue('lengte wimper');
    var key = type + '|' + length;
    if (key === lastKey) return;
    lastKey = key;

    if (img && type && CFG.images) {
      var styleKey = /monica/i.test(type) ? 'monica' : (/shei/i.test(type) ? 'shei' : '');
      if (styleKey && CFG.images[styleKey]) img.src = CFG.images[styleKey];
    }

    if (sub) {
      var parts = [];
      if (type) parts.push(prettify(type));
      if (length) parts.push(String(length).replace(/\s+/g, ' ').trim());
      if (parts.length) sub.textContent = parts.join(' · ');
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  document.addEventListener('change', schedule, true);

  if (window.MutationObserver) {
    var container = document.querySelector('.product__info-container') || document.body;
    new window.MutationObserver(schedule).observe(container, { childList: true, subtree: true });
  }
})();
